<template>
    <TableFilter :filter-refs="$refs"
                 @apply-filter="applyFilter"
    >
        <div class="filter_item">
            <EnumFilter :label-text="$t('common.type')"
                        column-name="type"
                        :enum-def="enumDef.invoiceType"
						:exclude="(value) => enumDef.invoiceType.excludeInFilter(value)"
                        ref="filter_type"
            ></EnumFilter>
            <TextFilter :label-text="$t('common.invoiceNumber')"
                        column-name="invoiceNumber"
                        ref="filter_invoiceNumber"
            ></TextFilter>
            <FromToFilter :label-text="$t('common.amount')"
                          column-name="amount"
                          ref="filter_amount"
            ></FromToFilter>
            <DateFilter :label-text="$t('common.invoiceDate')"
                        column-name="creationTime"
                        ref="filter_creationTime"
            ></DateFilter>
        </div>
    </TableFilter>
</template>

<script>

import EnumFilter from "@/components/newFilter/EnumFilter";
import {enumDef} from "@/common/enumDefs";
import TextFilter from "@/components/newFilter/TextFilter";
import FromToFilter from "@/components/newFilter/FromToFilter";
import DateFilter from "@/components/newFilter/DateFilter";
import TableFilter from "@/components/newFilter/TableFilter";

export default {
    components: {
        TableFilter,
        DateFilter,
        FromToFilter,
        TextFilter,
        EnumFilter
    },
    data() {
        return {
            enumDef: enumDef
        };
    },
    methods: {
        applyFilter(filters) {
            this.$emit("apply-filter", filters);
        }
    },
};
</script>
